import { useState, useCallback } from 'react'

export const useBooleanState = (intialState = false): [boolean, () => void, () => void] => {
  const [show, setShow] = useState<boolean>(intialState)
  const onShow =  useCallback(() => setShow(true), [setShow])
  const onHide =  useCallback(() => setShow(false), [setShow])
  return [ show, onShow, onHide ]
}
